import React, { useState } from "react";
import "./AboutPage.css";
import "./Education.css";
import Navbar from "./Navbar";
import BreadCrumb from "./BreadCrumb";
import Footer from "./Footer";
import Download from "./Download";
import MediaCenter from "./MediaCenter";
import Newsletter from "./Newsletter";


const Education = () => {
    return (
        <>
            <Navbar />
            <BreadCrumb />
            <div className="about-container">
                <section className="about-section risefx-benefits-section education-full-section">
                    <div className="risefx-container education-container">
                        <h1 className="risefx-title">Education</h1>
                        <p className="risefx-description">
                            Education plays a vital role in shaping the future by providing knowledge, skills, and values necessary for personal and professional growth.
                        </p>

                        {/* Sections Start */}
                        <div className="education-sections">

                            {/* --------------------------------------------------------------------education section 1 ---------------------------------------------------------- */}

                            <section className="education-section education-section-1">
                                <div className="education-content">
                                    <h2 className="education-title">What Is “Forex-Fx”</h2>
                                    <p className="education-text">
                                        Foreign exchange, in short, we call it Forex, is the global market where one currency is exchanged for another. It’s the largest and most liquid financial market in the world, with average traded values reaching trillions of dollars per day. It includes all currencies in the world and operates 24 hours a day.
                                    </p>
                                    <p className="education-text">
                                        The foreign exchange market is often referred to as ‘FOREX’, ‘FX’, or ‘Spot FX’. Forex traders exchange two different currencies and make profits from the price difference in buy and sell prices.
                                    </p>
                                    <p className="education-text">
                                        As the value of currencies keeps changing, traders can earn profits by trading at the right timing.
                                    </p>
                                    <div className="education-example">
                                        <h3 className="example-title">Example</h3>
                                        <p className="example-text">
                                            When the US dollar is expected to weaken in value relative to the euro, forex traders would sell dollars to buy euros.
                                        </p>
                                        <p className="example-text">
                                            If the euro actually appreciates, traders would sell euros and buy back more dollars than they originally had, making a profit.
                                        </p>
                                    </div>
                                </div>
                                <div className="education-image">
                                    <img src="/images/risefxmobile.png" alt="Forex Trading" className="forex-image" />
                                </div>
                            </section>

                            {/* --------------------------------------------------------------------education section 2 ---------------------------------------------------------- */}

                            <section className="education-section education-section-2">
                                <h2 className="education-title">Currency Pairs</h2>
                                <p className="education-text">
                                    Currencies are quoted in pairs, such as <strong>EUR/USD</strong> or <strong>USD/JPY</strong>.
                                    The first listed currency is known as the <strong>base currency</strong>, while the second is called the <strong>counter or quote currency</strong>.
                                </p>
                                <p className="education-text">
                                    The base currency represents how much of the quote currency is needed for you to get one unit of the base currency.
                                </p>

                                <div className="currency-pair-container">
                                    <div className="currency-box">
                                        <div className="currency-data">
                                        <img src="/images/eur-flag.png" alt="EUR Flag" className="currency-flag" />
                                        <h3 className="currency-name">EUR</h3>
                                        </div>
                                        <p className="currency-type">BASE </p>
                                        <p className="currency-type-1">Currency</p>
                                    </div>

                                    <div className="currency-box">
                                        <div className="currency-data">
                                        <img src="/images/usd-flag.png" alt="USD Flag" className="currency-flag" />
                                        <h3 className="currency-name">USD</h3>
                                        </div>
                                        <p className="currency-type">QUOTE</p>
                                        <p className="currency-type-1">Currency</p>
                                    </div>
                                </div>

                                <p className="exchange-rate">EUR/USD <span className="rate">1.21587</span></p>
                                <p className="exchange-description">One euro is worth <strong>1.21587 dollars</strong></p>
                            </section>

                            {/* --------------------------------------------------------------------education section 3 ---------------------------------------------------------- */}

                            <section className="education-section education-section-3">
                                <h2 className="section-title">Exchange Rate</h2>
                                <p className="section-description">
                                    The exchange rate is the price of one currency in terms of another currency. It tells you how much of one currency traders need to spend to purchase one unit of another currency.
                                </p>
                                <h3 className="example-title">Example: USD/JPY Exchange Rate</h3>

                                <div className="image-container">
                                    <img src="/images/trade-chart.png" alt="Exchange Rate Chart" className="exchange-image" />
                                </div>

                                <p className="example-description">
                                    Lot is the way to measure the position size or the volume of a trade.
                                </p>

                                <div className="lot-tables">
                                    <div className="table-container">
                                        <h3 className="table-title">Currency Pairs</h3>
                                        <table className="lot-table">
                                            <thead>
                                                <tr>
                                                    <th>Lot Name</th>
                                                    <th>Lot Size</th>
                                                    <th>Volume/Units</th>
                                                    <th>1 PIP Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>Micro</td><td>0.01</td><td>1000</td><td>$0.10</td></tr>
                                                <tr><td>Mini</td><td>0.1</td><td>10,000</td><td>$1</td></tr>
                                                <tr><td>STD</td><td>1</td><td>100,000</td><td>$10</td></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="table-container">
                                        <h3 className="table-title">Gold (XAUUSD) & Crude Oil (USOUSD)</h3>
                                        <table className="lot-table">
                                            <thead>
                                                <tr>
                                                    <th>Lot Name</th>
                                                    <th>Lot Size</th>
                                                    <th>Volume/Units</th>
                                                    <th>1 PIP Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>Micro</td><td>0.01</td><td>1</td><td>$0.10</td></tr>
                                                <tr><td>Mini</td><td>0.10</td><td>10</td><td>$1</td></tr>
                                                <tr><td>STD</td><td>1</td><td>100</td><td>$10</td></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="table-container">
                                        <h3 className="table-title">Silver (XAGUSD)</h3>
                                        <table className="lot-table">
                                            <thead>
                                                <tr>
                                                    <th>Lot Name</th>
                                                    <th>Lot Size</th>
                                                    <th>Volume/Units</th>
                                                    <th>1 PIP Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>Micro</td><td>0.01</td><td>50</td><td>$0.10</td></tr>
                                                <tr><td>Mini</td><td>0.10</td><td>500</td><td>$1</td></tr>
                                                <tr><td>STD</td><td>1</td><td>5000</td><td>$10</td></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="table-container">
                                        <h3 className="table-title">Natural Gas (NG)</h3>
                                        <table className="lot-table">
                                            <thead>
                                                <tr>
                                                    <th>Lot Name</th>
                                                    <th>Lot Size</th>
                                                    <th>Volume/Units</th>
                                                    <th>1 PIP Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>Micro</td><td>0.01</td><td>100</td><td>$0.10</td></tr>
                                                <tr><td>Mini</td><td>0.10</td><td>1000</td><td>$1</td></tr>
                                                <tr><td>STD</td><td>1</td><td>10,000</td><td>$10</td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>

                            {/* --------------------------------------------------------------------education section 4 ---------------------------------------------------------- */}

                            <section className="education-section education-section-4">
                                <h2 className="section-title">What Is PIP?</h2>
                                <p className="section-description">
                                    “PIP” Stands for Point In Percentage, which is a unit of movement in the exchange rate.
                                </p>
                                <p className="section-description">
                                    A pip is usually the last decimal place of a quotation.
                                </p>
                                <p className="section-description">
                                    For most currency pairs, the fourth decimal place is counted as a "pip," and one pip is <strong>0.0001</strong>.
                                </p>
                                <p className="section-description">
                                    For Japanese Yen-related currency pairs, the second decimal place is counted as "pips," and one pip is <strong>0.01</strong>.
                                </p>


                                <h3 className="example-title">Example:</h3>
                                <ul className="example-list">
                                    <li>EUR/USD rises from <strong>1.16997</strong> to <strong>1.17007</strong>, the EUR/USD has risen <strong>1 pip</strong>.</li>
                                    <li>USD/JPY drops from <strong>110.200</strong> to <strong>110.145</strong>, the USD/JPY has dropped <strong>5.5 pips</strong>.</li>
                                </ul>
                            </section>

                            {/* --------------------------------------------------------------------education section 5 ---------------------------------------------------------- */}

                            <section className="education-section education-section-5">
                                <h2 className="section-title">Bid Price</h2>
                                <p className="section-description">
                                    The <strong> Bid</strong>  represents the price at which a trader can <strong>sell</strong>  the base currency, which is shown to the <strong> left</strong>  in a currency pair.
                                </p>

                                
                                <h3 className="example-title">Example:</h3>
                                <p className="example-text">
                                    In the quote <strong>USD/JPY 113.67/69</strong>, the base currency is <strong> USD</strong> , and the bid price is <strong> 113.67</strong> .
                                    This means you can sell <strong> one US Dollar</strong>  for <strong>113.67 Japanese Yen</strong> .
                                </p>
                            </section>

                            {/* --------------------------------------------------------------------education section 6 ---------------------------------------------------------- */}

                            <section className="education-section education-section-6">
                                <h2 className="section-title">Ask (Offer) Price</h2>
                                <p className="section-description">
                                    The <strong> Ask</strong>  represents the price at which a trader can <strong> buy</strong>  the base currency, which is shown to the <strong> left</strong>  in a currency pair.
                                </p>

                                
                                <h3 className="example-title">Example:</h3>
                                <p className="example-text">
                                    In the quote <strong>USD/CHF 0.9997/99</strong>, the base currency is <strong> USD</strong> , and the ask price is <strong> 0.9999</strong> .
                                    This means you can <strong> buy one US Dollar<strong>  for </strong> 0.9999 Swiss Francs</strong> .
                                </p>

                                <p className="spread-info">
                                    The  difference  between the bid and ask price is called the <strong> "Spread"</strong> .
                                </p>
                            </section>

                            {/* --------------------------------------------------------------------education section 7 ---------------------------------------------------------- */}

                            <section className="education-section education-section-7">
                                <h2 className="section-title">Spreads</h2>
                                <p className="section-description">
                                    There are <strong>buy</strong> and <strong>sell</strong> prices for every currency pair, and the difference between these prices is called the <strong>spread</strong>.
                                </p>

                                
                                <h3 className="example-title">Example:</h3>
                                <p className="example-text">
                                    If the <strong>EUR/USD</strong> pair's <strong>Sell price</strong> is <strong>1.4079</strong> and the <strong>Buy price</strong> is <strong>1.4081</strong>, then the <strong>spread</strong> is <strong>2 pips</strong>.
                                </p>
                            </section>

                            {/* --------------------------------------------------------------------education section 8 ---------------------------------------------------------- */}
                            <section className="education-section education-section-8">
                                <h2 className="section-title">Leverage</h2>
                                <p className="section-description">
                                    Forex allows traders to trade a large amount with a relatively small fund.
                                    The amount of leverage on your account partly determines the amount of funds you need to put up for a trade.
                                    <strong> Leverage</strong> gives the trader the ability to trade larger amounts of currency with a smaller deposit amount.
                                </p>

                                {/* Example Box */}
                                <div className="example-box">
                                    <h3 className="example-title">Example:</h3>
                                    <p className="example-text">
                                        With a <strong>$200</strong> deposit and a leverage of <strong>1:500</strong>,
                                        this would allow you to trade up to <strong>$10,000</strong> worth of currency.
                                    </p>
                                </div>
                            </section>

                            {/* --------------------------------------------------------------------education section 9 ---------------------------------------------------------- */}
                            <section className="education-section education-section-9">
                                <h2 className="section-title">Margin</h2>
                                <p className="section-description">
                                    It is the necessary amount you need to have in your trading account in order to open a relevant transaction.
                                </p>
                                <p className="section-description">
                                    <strong>Free Margin</strong> is the available amount of money, which can be used to open new positions.
                                </p>

                                {/* Formula Box */}
                                <div className="formula-box">
                                    <h3 className="formula-title">Margin Formula:</h3>
                                    <div className="formula-example">
                                        <strong>Margin = </strong>
                                        <div className="example-formula">
                                          <p className="formula-top">CMP (Current Market Price) × Lot Size × Volume</p>
                                          <p className="formula-bottom">Leverage</p>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* --------------------------------------------------------------------education section 10 ---------------------------------------------------------- */}
                            <section className="education-section education-section-10">
                                <h2 className="section-title">Rollover</h2>
                                <p className="section-description">
                                    Rollover, also known as <strong>swap</strong>, is the interest earned or paid for a position kept open overnight,
                                    which is caused by an interest rate differential between the currency pair traded.
                                </p>
                            </section>

                        </div>
                        {/* Sections End */}
                    </div>
                </section>
            </div>
            <MediaCenter />
            <Download />
            <Newsletter />
            <Footer />
        </>
    );
};

export default Education;
